import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

export interface DashboardSummary {
  extraServices: {
    openInternal: number;
    confirmedNotSent: number;
    atCustomer: number;
    customerConfirmed: number;
    customerRejected: number;
    total: number;
  };
  approvals: {
    pending: number;
    confirmed: number;
    rejected: number;
  };
}

export function useDashboardSummary() {
  return useQuery({
    queryKey: ['dashboard-summary'],
    queryFn: () => api<DashboardSummary>('/api/dashboard/summary'),
  });
}
